package team.platforma.multiplatform_material_extension

import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.material3.Scaffold
import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.window.CanvasBasedWindow
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.coroutines.delay
import org.w3c.dom.HTMLCanvasElement
import org.w3c.dom.HTMLElement
import org.w3c.dom.HTMLIFrameElement
import org.w3c.dom.events.Event

actual fun isMobilePlatform(): Boolean {
    val userAgent = window.navigator.userAgent
    return userAgent.contains("Mobi", ignoreCase = true)
}

@Composable
actual fun setTransparentSystemBars() {
}

actual fun correction(dp: Dp): Float {
    return dp.value * 2
}

@Composable
actual fun trackWebKeyboardHeight(onHeightChanged: (Int) -> Unit) {
    val visualViewport = js("window.visualViewport")
    if (visualViewport != undefined) {
        visualViewport.addEventListener("resize") {
            val currentHeight = js("window.innerHeight").unsafeCast<Int>()
            val viewportHeight = js("visualViewport.height").unsafeCast<Double>().toInt()
            val keyboardHeight = (currentHeight - viewportHeight).coerceAtLeast(0)
            onHeightChanged(keyboardHeight)
        }
    } else {
        // Fallback для браузеров без visualViewport
        val initialHeight = js("window.innerHeight").unsafeCast<Int>()
        window.addEventListener("resize", {
            val currentHeight = js("window.innerHeight").unsafeCast<Int>()
            val keyboardHeight = (initialHeight - currentHeight).coerceAtLeast(0)
            onHeightChanged(keyboardHeight)
        })
    }
}

actual fun webWightCorrection(int: Int): Int = int

@Composable
actual fun isDarkTheme(): Boolean {
    val mediaQuery = window.matchMedia("(prefers-color-scheme: dark)")
    return mediaQuery.matches
}


actual class JsFullScreenIframe actual constructor(
    private val rootId: String,
    private val iframeId: String,
    private val canvasId: String
) {


    @OptIn(ExperimentalComposeUiApi::class)
    @Composable
    actual fun show(
        url: String,
        topBar: @Composable () -> Unit,
        bottomBar: @Composable () -> Unit
    ) {

        var mPaddingValues by remember { mutableStateOf(PaddingValues()) }

        val iframe = document.getElementById(iframeId) as HTMLIFrameElement
        val containerHeight = (document.getElementById(rootId) as HTMLElement).clientHeight


        iframe.apply {
            src = url
            width = "50%"
            height = "100%"
            align = ""
            frameBorder = "0"
            style.position = "absolute"
            hidden = false

            val topPaddingPx = mPaddingValues.calculateTopPadding().value
            val bottomPaddingPx = mPaddingValues.calculateBottomPadding().value

            style.top = "${topPaddingPx}px"
            style.bottom = "${bottomPaddingPx}px"
            style.height = "${containerHeight - topPaddingPx - (bottomPaddingPx + 4)}px"
            style.padding = "0 16px"
            style.left = "50%"
            style.transform = "translateX(-50%)"
            style.minWidth = "400px"
            style.zIndex = "1"
        }


        val canvas = document.getElementById(canvasId) as HTMLCanvasElement

        canvas.apply {
            style.width = "100%"
            style.height = "100%"
            style.position = "absolute"
            style.top = "0px"
            style.left = "0px"
            style.backgroundColor = "transparent"
            style.zIndex = "0"
            hidden = false
        }



        CanvasBasedWindow(canvasElementId = canvasId) {

            Scaffold(
                modifier = Modifier,
                containerColor = Color.White,
                topBar = {
                    topBar()
                },
                bottomBar = {
                    bottomBar()
                }
            ) { paddingValues ->
                mPaddingValues = paddingValues
            }

        }
    }

    actual fun hide() {
        val iframe = document.getElementById(iframeId) as HTMLIFrameElement
        iframe.src = ""
        iframe.hidden = true
        val canvas = document.getElementById(canvasId) as HTMLElement
        canvas.hidden = true
    }
}

@Composable
actual fun getScreenSize(): Pair<Int, Int> {
    val screenSize = remember { mutableStateOf(Pair(0, 0)) }
    LaunchedEffect(Unit) {
        delay(50)
        screenSize.value = Pair(window.innerWidth, window.innerHeight)
    }
    DisposableEffect(Unit) {
        val listener: (Event) -> Unit = {
            screenSize.value = Pair(window.innerWidth, window.innerHeight)
        }
        window.addEventListener("resize", listener)
        onDispose {
            window.removeEventListener("resize", listener)
        }
    }
    return screenSize.value
}